import { Component, OnDestroy, OnInit } from '@angular/core';
import { DateObj } from '@impact/data';
import { Subject } from 'rxjs';
import { take, takeUntil } from 'rxjs/operators';

import { CHECKOUT_STEP, CheckoutFlowService } from '../../../../../../checkout/checkout-flow.service';
import { CheckoutService } from '../../../../../../checkout/checkout.service';
import { getDateObjFromDate, getTimeFromUTCDate } from '../../../../../../core/helpers';

@Component({
    selector: 'app-delivery-summary',
    template: `
        <ng-container *ngIf="checkoutService.getCheckoutData() | async as cd">
            <section
                class="summary"
                [ngClass]="{ 'summary--active': true, 'summary--has-error': hasValidationError }"
                appCircleCheckmark
                [condition]="!hasValidationError"
                appCircleError
                [errorCondition]="hasValidationError"
            >
                <div class="summary__header">
                    <h3 class="h5 no-margin" [ngSwitch]="!cd.pickup">
                        <ng-container *ngSwitchCase="true">
                            {{ 'checkout.summary_step____delivery_section____delivery_headline' | translate }}
                        </ng-container>
                        <ng-container *ngSwitchCase="false">
                            {{ 'checkout.summary_step____delivery_section____pickup_headline' | translate }}
                        </ng-container>
                    </h3>
                    <app-button
                        (click)="checkoutflowService.goToStep(step)"
                        [buttonClass]="'button--minimal theme-text'"
                        [title]="(hasValidationError ? 'checkout.summary_step____button_currect_step' : 'buttons.edit') | translate"
                    >
                    </app-button>
                </div>
                <div class="summary__content text-small">
                    <div *ngIf="cd.delivery" class="unstyled-table unstyled-table--first-child-bold" role="table">
                        <div class="unstyled-table__row" role="row">
                            <div class="unstyled-table__cell" role="cell">
                                {{ 'checkout.summary_step____delivery_section____address' | translate }}
                            </div>
                            <div class="unstyled-table__cell" role="cell">
                                {{ cd.delivery?.address?.address }}{{ cd.delivery?.address?.address && ',' }} {{ cd.delivery?.address?.zipCode }}
                                {{ cd.delivery?.address?.city }}
                            </div>
                        </div>
                        <div class="unstyled-table__row" role="row" *ngIf="cd.delivery?.dateTime">
                            <div class="unstyled-table__cell" role="cell">{{ 'checkout.summary_step____delivery_section____time' | translate }}</div>
                            <div class="unstyled-table__cell" role="cell">{{ time }} - {{ date?.day }}/{{ date?.month }}/{{ date?.year }}</div>
                        </div>
                    </div>

                    <div *ngIf="cd.pickup" class="unstyled-table unstyled-table--first-child-bold" role="table">
                        <div class="unstyled-table__row" role="row">
                            <div class="unstyled-table__cell" role="cell">
                                {{ 'checkout.summary_step____delivery_section____dealership' | translate }}
                            </div>
                            <div class="unstyled-table__cell" role="cell">
                                {{ cd.dealer?.dealerName }}
                            </div>
                        </div>
                        <div class="unstyled-table__row" role="row" *ngIf="cd.pickup?.dateTime">
                            <div class="unstyled-table__cell" role="cell">{{ 'checkout.summary_step____delivery_section____time' | translate }}</div>
                            <div class="unstyled-table__cell" role="cell">{{ time }} - {{ date?.day }}/{{ date?.month }}/{{ date?.year }}</div>
                        </div>
                    </div>
                    <div *ngIf="!cd.pickup && !cd.delivery" class="unstyled-table unstyled-table--first-child-bold" role="table">
                        <div class="unstyled-table__row" role="row">
                            <div class="unstyled-table__cell" role="cell">
                                {{ 'checkout.summary_step____delivery_section____delivery_method' | translate }}
                            </div>
                            <div class="unstyled-table__cell" role="cell">
                                {{ 'checkout.summary_step____delivery_section____non_chosen' | translate }}
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </ng-container>
    `,
})
export class DeliverySummaryComponent implements OnInit, OnDestroy {
    step = CHECKOUT_STEP.CS_DELIVERY;
    time?: string;
    date?: DateObj;
    hasValidationError?: boolean;
    private readonly unsubscribe = new Subject<void>();

    constructor(public checkoutService: CheckoutService, public checkoutflowService: CheckoutFlowService) {}

    ngOnInit() {
        this.checkoutService
            .getCheckoutData()
            .pipe(takeUntil(this.unsubscribe))
            .subscribe(({ delivery, pickup }) => {
                const data = delivery || pickup;
                if (data?.dateTime) {
                    const date = new Date(data?.dateTime);
                    this.time = getTimeFromUTCDate(date);
                    this.date = getDateObjFromDate(date);
                }
            });
        this.checkoutService.purchaseOrderValidation$.pipe(take(2)).subscribe((data) => {
            if (data) {
                this.hasValidationError = !!data?.errors?.find(
                    (e) => e.property?.split('.')?.[0] === 'Delivery' || e.property?.split('.')?.[0] === 'Pickup'
                );
            }
        });
    }

    ngOnDestroy() {
        this.unsubscribe.next();
        this.unsubscribe.complete();
    }
}
